export { default } from './ForecastDayContent';
